import React from "react";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "../../lib/api";

const fail = (e) => toast.error(formatApiErrorDetail(e.response?.data?.detail) || "Something went wrong.");

export const ReceiptActions = ({ kind, id, className = "" }) => {
  const download = () => api.get(`/admin/receipts/${kind}/${id}`, { responseType: "blob" }).then(({ data, headers }) => {
    const a = document.createElement("a");
    a.href = URL.createObjectURL(data);
    a.download = (headers["content-disposition"] || "").match(/filename="(.+)"/)?.[1] || "receipt.pdf";
    a.click();
    URL.revokeObjectURL(a.href);
  }).catch(() => toast.error("Couldn't create the receipt."));
  const email = () => window.confirm("Email the PDF receipt to the patient again?") &&
    api.post(`/admin/receipts/${kind}/${id}/email`).then(({ data }) => toast.success(`Receipt emailed to ${data.to}.`)).catch(fail);
  return (
    <span className={`inline-flex gap-3 ${className}`}>
      <button type="button" className="underline text-bronze-dark whitespace-nowrap" onClick={download} data-testid={`receipt-download-${id}`}>Receipt PDF</button>
      <button type="button" className="underline text-bronze-dark whitespace-nowrap" onClick={email} data-testid={`receipt-email-${id}`}>Email receipt</button>
    </span>
  );
};
